import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-admin', 'true');
    return () => root?.removeAttribute('data-admin');
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!loginId || !password) {
      setError('아이디와 비밀번호를 입력해주세요.');
      return;
    }

    setBusy(true);
    setError('');

    try {
      const q = query(collection(db, 'admin'), where('loginId', '==', loginId.trim()));
      const snap = await getDocs(q);

      if (snap.empty) {
        setError('등록되지 않은 관리자 계정입니다.');
        return;
      }

      const adminDoc = snap.docs[0];
      const adminData = adminDoc.data();

      if (adminData.password !== password) {
        setError('비밀번호가 올바르지 않습니다.');
        return;
      }

      localStorage.setItem('adminSession', JSON.stringify({
        id: adminDoc.id,
        loginId: adminData.loginId,
        name: adminData.name,
        rank: adminData.rank,
        loggedInAt: new Date().toISOString(),
      }));

      navigate('/admin', { replace: true });
    } catch (err) {
      console.error('관리자 로그인 실패:', err);
      setError('로그인에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Screen>
      <Card>
        <LogoText>조군산업</LogoText>
        <LogoSub>REXCRETE Admin</LogoSub>

        <Form onSubmit={handleLogin}>
          <InputGroup>
            <Label>아이디</Label>
            <Input
              type="text"
              placeholder="관리자 아이디"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              autoFocus
            />
          </InputGroup>

          <InputGroup>
            <Label>비밀번호</Label>
            <Input
              type="password"
              placeholder="비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </InputGroup>

          {error && <ErrorText>{error}</ErrorText>}

          <LoginBtn type="submit" disabled={busy}>
            {busy ? '로그인 중...' : '관리자 로그인'}
          </LoginBtn>
        </Form>

        <BackLink onClick={() => navigate('/login')}>
          일반 로그인으로 돌아가기
        </BackLink>
      </Card>
    </Screen>
  );
};

export default AdminLoginPage;

const Screen = styled.div`
  min-height: 100vh;
  background: #2C3640;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 380px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.3);
  text-align: center;
`;

const LogoText = styled.div`
  font-size: 22px;
  font-weight: 500;
  color: #1E2A32;
  letter-spacing: -0.5px;
`;

const LogoSub = styled.div`
  font-size: 12px;
  color: #8C9AA4;
  margin-top: 4px;
  margin-bottom: 32px;
  letter-spacing: 0.5px;
`;

const Form = styled.form`
  text-align: left;
`;

const InputGroup = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 400;
  color: #3D4F5F;
  margin-bottom: 8px;
`;

const Input = styled.input`
  width: 100%;
  padding: 13px 16px;
  border: 1.5px solid #D9DDD6;
  border-radius: 10px;
  font-size: 15px;
  color: #1E2A32;
  transition: all 0.2s;

  &::placeholder { color: #8C9AA4; }
  &:focus {
    border-color: #4A6741;
    box-shadow: 0 0 0 3px rgba(74, 103, 65, 0.08);
  }
`;

const ErrorText = styled.p`
  color: #C0392B;
  font-size: 13px;
  margin-bottom: 8px;
`;

const LoginBtn = styled.button`
  width: 100%;
  padding: 14px;
  border-radius: 10px;
  background: linear-gradient(135deg, #3B5534 0%, #4A6741 100%);
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 1px;
  margin-top: 4px;
  transition: all 0.2s;

  &:hover { box-shadow: 0 4px 12px rgba(74, 103, 65, 0.25); }
  &:active { transform: scale(0.98); }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

const BackLink = styled.div`
  margin-top: 20px;
  font-size: 13px;
  color: #8C9AA4;
  cursor: pointer;
  &:hover { color: #4A6741; }
`;
